/* eslint-disable @next/next/no-img-element */
import PencilIcon from "../../../icons/PencilIcon";
import { Button } from "../../../shadcn/components/ui/button";
import { useRouter } from "next/router";
import { getWatermarkedImgixUrl } from "services";

interface CardData {
  details?: { [key: string]: string };
  title?: string;
  uuid: any;
  propertyImage?: any;
}

export const PYPDetailsCard = ({
  details,
  title,
  uuid,
  propertyImage,
}: CardData) => {
  const router = useRouter();
  const handleClick = () => {
    router.push(`/post-your-property/${uuid}`);
  };

  function formatString(input: string): string {
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return (
    <>
      <div className="mt-5 mid:mt-0 mid:max-w-[516px] w-full clip-path-webClipPolygonTopLeft">
        <img
          src={
            propertyImage?.id
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${propertyImage?.id}`,
                )
              : "../../PYPSuccess2.png"
          }
          className=" w-full"
          alt=""
        />

        <div className="w-full bg-brand-lightPink px-3 lg:px-5 pt-5 pb-[50px]  ">
          {" "}
          <div className="w-full justify-between flex">
            <p className="font-openSans capitalize font-semibold text-mobile-subheading lg:text-[20px] leading-6 lg:leading-[27px] text-brand-bgBlack">
              {title}
            </p>
            <Button
              variant={"custom"}
              size={"custom"}
              className="hover:cursor-pointer underline "
              onClick={handleClick}
            >
              <PencilIcon className=" " />
              <p className="ml-2 hidden lg:flex font-openSans font-semibold text-mobile-body-md lg:text-[20px] leading-5 lg:leading-7">
                Edit
              </p>
            </Button>
          </div>{" "}
          <div className="mt-8">
            <ul className="grid grid-cols-3 gap-y-8 w-full">
              {details &&
                Object.entries(details).map(([key, value]) => (
                  <li key={key} className={`${value ? "" : "hidden"}`}>
                    <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
                      {formatString(key)}:{" "}
                    </p>
                    <p className="font-openSans capitalize font-normal text-web-body-sm leading-4 text-brand-textGrey">
                      {value}
                    </p>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PYPDetailsCard;
